import { Component, Vue, Prop as prop, Watch as watch, Watch } from 'nuxt-property-decorator';
import SwiperCore, { Swiper, Thumbs } from 'swiper';
import FsLightbox from "fslightbox-vue"
import supportsWebP from 'supports-webp'; 


SwiperCore.use([Thumbs]);

@Component({
    components: {
        sliderPicture: require('~/components/common/image/').default,
        FsLightbox
    },
})
export default class ImageSliderComponent  extends Vue {

    @prop({required: true})
    public images: string[];

    @prop({default: () => []})
    public videos: string[];

    @prop({required: true})
    public aspect: number;

    @prop({type: Boolean, default: false})
    public useShadow: boolean;

    thumbsSwiper = null;

    showLightbox = false;
    showIdx = 0;

    thumbsGallery: Swiper = null;
    mainGallery: Swiper = null;
    isSupportsWebp = false;

    mounted() {

        supportsWebP.then((value) => {
            this.isSupportsWebp = value;
        })

        this.thumbsGallery = new Swiper(this.$refs['thumbs-slider'] as HTMLElement, {
            spaceBetween: 20,
            slidesPerView: 3,
            loop: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        
        this.mainGallery = new Swiper(this.$refs['main-slider'] as HTMLElement, {
            spaceBetween: 20,
            loop: true,
            // navigation: {
            //   nextEl: '.arrow.right',
            //   prevEl: '.arrow.left',
            // },
            thumbs: {
              swiper: this.thumbsGallery,
            },
            on: {
                click: (swiper, event) => {
                    if ((event.target as HTMLElement).classList.contains('arrow')) {
                        return;
                    }

                    this.showLightbox = !this.showLightbox;

                    let idx = (swiper.activeIndex - 1);
                    if (idx < 0) {
                        idx += (this.images.length + this.videos.length);
                    }

                    this.showIdx = idx % (this.images.length + this.videos.length);
                }
            }
        });
    }

    @Watch('images')
    onImagesChange() {

        // 2 слайда на общее количество 
        let count = this.mainGallery.slides.length - 2;

        if (count < this.images.length) {
            count = this.images.length;
        } else if (count > this.images.length) {
            for (let i = this.images.length; i < count; i++) {
                this.removeSlide(i);
            }
            count = this.images.length;
        }

        for (let i = 0; i < count; i++) {
            const image = new Image();
            image.src = this.renderImageSrc(this.images[i]);
            image.onload = async () => {
                this.addSlide(i, image.src);
            }
        }
    }

    removeSlide(index: number|number[]) {
        this.mainGallery.removeSlide(index);
        this.thumbsGallery.removeSlide(index);
    }

    addSlide(idx: number, src: string) {
        const image = this.renderNewImage(src);

        if (!this.updateSlideContent(idx, image)) {

            const content = `<div class="swiper-slide">${image}</div>`;

            this.mainGallery.removeSlide(idx);
            this.thumbsGallery.removeSlide(idx);
            this.mainGallery.addSlide(idx, content);
            this.thumbsGallery.addSlide(idx, content);

            this.updateDuplicateContent(idx, image);
        } 
    }

    updateSlideContent(idx, content: string): boolean {
        const elements = this.$el.querySelectorAll(`.swiper-slide[data-swiper-slide-index='${idx}']`);

        if (!elements.length) {
            return false;
        }

        elements.forEach((el) => {
            el.innerHTML = content;
        });

        return true;
    }

    updateDuplicateContent(idx, content: string) {
        const elements = this.$el.querySelectorAll(`.swiper-slide.swiper-slide-duplicate[data-swiper-slide-index='${idx}']`);

        elements.forEach((el) => {
            el.innerHTML = content;
        });
    }

    slidePrev(shit = false) {
        (shit ? this.thumbsGallery : this.mainGallery)?.slidePrev();
    }

    slideNext(shit = false) {
        (shit ? this.thumbsGallery : this.mainGallery)?.slideNext();
    }

    beforeDestroy() {
        this.mainGallery.destroy();
        this.thumbsGallery.destroy();
    }

     /** хуета, но а что делать? */
    private renderImageSrc(src: string) {
        return `/_t/${src}/product.${this.isSupportsWebp ? 'webp' : 'jpeg'}`;
    }

   
    private renderNewImage(src: string) {
        return `<img class="__picture"  src="${src}">`;
    }

    get displayImages() {
        return this.images;
    }

    get style() {
        return {
            height: 0,
            paddingTop: `${Math.round(this.aspect * 100)}%`
        };
    }

    get fsLightItems() {
        return this.images.map(el => {
            const id = el.toString();

            const prependPath = id.substring(0, 3).padStart(3, '0');

            return `https://cdn.triya.ru/_t/${prependPath}/${el}.${this.$store.state.imageFormat}`;
        }).concat(this.videos.map((el) => 'https://www.youtube.com/watch?v=' + el));
    }
}
